import React from "react";
import ChatHeader from "../ChatLayout/ChatHeader";

const ProjectDirectories = ({memberList, activeChannel, directoryName}) => {
  return (
    <div className="chat-wrapper">
      <div className="chat-main">
        <ChatHeader memberList={memberList} activeChannel={activeChannel} channelName={directoryName} />
      </div>
    </div>
  );
};

export default ProjectDirectories;
